// extracted by mini-css-extract-plugin
export default {"container":"f-dropdown_container__jY4zH","btn":"f-dropdown_btn__PsL+P","wrapper":"f-dropdown_wrapper__j+5Hr","drop":"f-dropdown_drop__xO-2F","drop1":"f-dropdown_drop1__JeqO0"};